<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width || '16'"
    :height="height || '16'"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M1.6001 3.6H14.4001M5.6001 1.2H10.4001M6.4001 11.6V6.8M9.6001 11.6V6.8M10.8001 14.8H5.2001C4.31644 14.8 3.6001 14.0837 3.6001 13.2L3.23482 4.43331C3.21588 3.97881 3.57923 3.6 4.03412 3.6H11.9661C12.421 3.6 12.7843 3.97881 12.7654 4.43331L12.4001 13.2C12.4001 14.0837 11.6838 14.8 10.8001 14.8Z"
      :stroke="color ? color : 'var(--text)'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  props: ["width", "height", "color"],
};
</script>
